import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { Controller, useForm, useWatch } from 'react-hook-form';

import {
  Button,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { CleaningServices } from '@mui/icons-material';
import { FaEye } from 'react-icons/fa';
import { IoAddCircle } from 'react-icons/io5';
import { MdModeEdit } from 'react-icons/md';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { HistoricoModal, InsertOrUpdateModal } from '../../Components/ControlMensajeria/Modal';

import Loading from '../../Components/Modals/Loading/Loader';

import { fetchAreasOrganizacionales, selectAllAreasOrganizacionales } from '../../redux/AreaOrganizacional/AreaOrganizacionalSlice';

import {
  fetchCambiarSuccess,
  fetchControlMensajeria,
  fetchControlMensajeriaCount,
  fetchGetEstados,
  fetchGetMensajeros,
  selectControlMensajeria,
  selectControlMensajeriaCount,
  selectEstados,
  selectIsLoading,
  selectIsSuccess,
  selectMensajeros,
  selectMessage,
} from '../../redux/ControlMensajeria/ControlMensajerioSlice';

import { fetchAllEmpleados } from '../../redux/Empleados/EmpleadosSlice';
import { EstadosControlCafeteriaEnum } from './Funcs/EstadosControlCafeteriaEnum';

import moment from 'moment';
import swal from 'sweetalert';
import { endpoints } from '../../redux/config';
import { getSignalRConnection } from '../../SignalR/signalRConnection';

// * VALOR INICIAL DEL MODAL PARA REGISTRAL O ACTUALIZAR SOLICITUD DE MENSAJERIA.
const initialValueModalRegisterOrUpdate = {
  open: false,
  controlMensajeria: {},
  editEnabled: false,
};

export const ControlMensajeria = () => {
  // ? HOOK-STATE MODALS
  const [openHistorico, setOpenHistorico] = useState({ open: false, historico: [] });
  const [openModalRegisterOrUpdate, setOpenModalRegisterOrUpdate] = useState(initialValueModalRegisterOrUpdate);

  // ? HOOK-STATE DE LISTAS
  const [listaAreasState, setListaAreasState] = useState([]);
  const [mensajeroList, setMensajeroList] = useState([]);
  const [estadosList, setEstadosList] = useState([]);

  // ? HOOK-STATE PARA EL PICKER
  const [isForcePickerOpen, setIsOpen] = useState(false);

  // ? USE-STATE PARA LA PAGINACION
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [skipRow, setSkipRow] = useState(0);

  // ? HOOK-REF PARA EL BOTON.
  const anchorRef = useRef(null);

  // * FORMATO DE LA ESTRUCTURA DEL OBJETO A ENVIAR A BD.
  const formSchema = Yup.object().shape({
    controlMensajeria: Yup.object().shape({
      id: Yup.number(),
      areaOrganizacionalId: Yup.number().required('El campo es requerido').notOneOf([0], 'Debe seleccionar una opción válida'),
      extension: Yup.number()
        .required('El campo es requerido')
        .transform((value, originalValue) => (originalValue === '' ? NaN : value)) // Evita que "" se convierta en NaN automáticamente
        .typeError('Debe ingresar un número válido') // Si no es un número, muestra este mensaje
        .notOneOf([0], 'El valor no puede ser 0, favor ingresar un número válido.'),
      motivo: Yup.string().required('El campo es requerido').min(5, 'El motivo es muy corto favor detallar su solicitud'),
      observaciones: openModalRegisterOrUpdate.editEnabled ? Yup.string().required('El campo es requerido') : Yup.string().nullable(),
      estadoId: openModalRegisterOrUpdate.editEnabled
        ? Yup.number().required('El campo es requerido').notOneOf([1], 'El campo es requerido')
        : Yup.number().required('El campo es requerido').notOneOf([0], 'El valor no puede ser 0, favor ingresar un número válido.'),
      usuarioSolicitante: Yup.number().required('El campo es requerido').notOneOf([0], 'Debe seleccionar una opción válida'),
      usuarioMensajero: openModalRegisterOrUpdate.editEnabled
        ? Yup.number().required('El campo es requerido').notOneOf([0], 'Debe seleccionar una opción válida')
        : Yup.number().nullable(),
      fechaCreacion: Yup.date().nullable(),
      departamentosRecepcion: Yup.array().nonNullable().of(Yup.number()).min(1, 'Debes seleccionar al menos una opción'),
    }),
  });

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-FORM
  const { control, reset } = useForm({
    defaultValues: {
      filtro: {
        estado: 0,
        mensajeroId: 0,
        areaOrganizacionalId: 0,
        usuarioSolicitante: 0,
        usuarioMensajero: 0,
        Fecha: new Date(),
        itemsPerPage: rowsPerPage,
        index: page,
      },
    },
  });

  // ? HOOK-FORM 2
  const form2 = useForm({
    defaultValues: {
      controlMensajeria: {
        id: 0,
        usuarioSolicitante: 0,
        areaOrganizacionalId: 0,
        usuarioMensajero: null,
        extension: null,
        estadoId: 1,
        motivo: '',
        observaciones: null,
        fechaCreacion: null,
        fechaAplazado: null,
        departamentosRecepcion: [],
      },
    },
    resolver: yupResolver(formSchema),
  });

  // ? HOOK-SELECTOR
  const isLoading = useSelector(selectIsLoading);
  const success = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);
  const estados = useSelector(selectEstados);
  const mensajeros = useSelector(selectMensajeros);
  const listAreaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const controlMensajeria = useSelector(selectControlMensajeria);
  const controlMensajeriaCount = useSelector(selectControlMensajeriaCount);

  // ? HOOK-WATCH
  const filtro = useWatch({
    control,
    name: 'filtro',
  });

  // * FUNCION PARA REFRESCAR LISTA.
  const refreshList = () => {
    dispatch(fetchControlMensajeria(filtro));
    dispatch(fetchControlMensajeriaCount(filtro));
  };

  // * FUNCIONES PARA PAGINACION.
  const handleChangePage = (event, newPage) => {
    setSkipRow(newPage * rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSkipRow(0);
  };

  // ? USE-EFFECT
  useEffect(() => {
    dispatch(fetchGetEstados());
    dispatch(fetchGetMensajeros());
    dispatch(fetchAreasOrganizacionales());
    dispatch(fetchAllEmpleados());
  }, []);

  useEffect(() => {
    refreshList();
  }, [filtro, page, rowsPerPage]);

  useEffect(() => {
    setListaAreasState([{ id: 0, nombre: 'Seleccionar Área' }, ...listAreaOrganizacionales]);

    setMensajeroList([{ id: 0, nombreEmpleado: 'Seleccionar Mensajero' }, ...mensajeros]);

    setEstadosList([{ id: 0, descripcion: 'Seleccionar estado' }, ...estados]);
  }, [listAreaOrganizacionales, mensajeros, estados]);

  useEffect(() => {
    if (success === 'success' && message.length > 0) {
      dispatch(fetchCambiarSuccess());
      swal('Exitoso!', message, 'success');
      setOpenModalRegisterOrUpdate({ initialValueModalRegisterOrUpdate, open: false });
      form2.reset();
    } else if (success === 'error') {
      swal('Error!', message, 'error');
    }
  }, [success, message]);

  // ? USE-EFFECT PARA INVOCAR Y RECIBIR DESDE EL WEB-SOCKET.
  useEffect(() => {
    let connectionRef = null;

    const setupSignalR = async () => {
      try {
        const conn = await getSignalRConnection(endpoints.notificaciones.hub);
        connectionRef = conn;

        conn.onclose((error) => {
          console.error('Conexión cerrada o perdida:', error);
        });

        conn.on('RefreshListControlMensajeria', () => {
          setTimeout(() => refreshList(), 1500);
        });

        await conn.start();
      } catch (error) {
        console.error('Error al establecer la conexión de SignalR:', error);
      }
    };

    setupSignalR();

    return () => {
      if (connectionRef) {
        connectionRef.off('RefreshListControlMensajeria');
      }
    };
  }, []);

  // * COMPONENTE PERSONALIZADO PARA DETERMINAR LOS COLORES SEGUN EL ESTADO.
  const ColorEstatus = ({ estado = '' }) => {
    // * REMOVER ESPACIOS.
    const estadoNormalized = estado.replace(/\s/g, '');

    const colors = {
      Pendiente: '#a5a5a5',
      Aplazado: '#ec7600',
      Completado: '#08b000',
      Enproceso: '#dfac00',
    };

    const textColor = colors[estadoNormalized];

    return (
      <Typography fontWeight="bold" textTransform="uppercase" color={textColor}>
        {estado}
      </Typography>
    );
  };

  return (
    <div className="container-fluid main" style={{ minHeight: '100vh' }}>
      <div className="row mt-2">
        <div className="col-md-12">
          <div className="d-flex">
            <div className="pt-2 ps-2" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <h4 style={{ textTransform: 'uppercase', margin: 0 }}>Control de mensajería -</h4>

              <Controller
                control={control}
                name="filtro.Fecha"
                render={({ field: { value, onChange } }) => (
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      open={isForcePickerOpen}
                      onClose={() => setIsOpen(false)}
                      value={value}
                      onChange={onChange}
                      PopperProps={{
                        anchorEl: anchorRef.current,
                      }}
                      renderInput={({ ref, inputProps, disabled, onChange, value, ...other }) => (
                        <div ref={ref} {...other}>
                          <input style={{ display: 'none' }} value={value} onChange={onChange} disabled={disabled} {...inputProps} />
                          <Button ref={anchorRef} onClick={() => setIsOpen((prev) => !prev)} type="button" sx={{ mt: 0 }} style={{ marginLeft: -10 }}>
                            <Typography fontSize={24} className="text-primary-mem">
                              {moment(filtro.Fecha).format('dddd DD [de] MMMM[,] YYYY')}
                            </Typography>
                          </Button>
                        </div>
                      )}
                    />
                  </LocalizationProvider>
                )}
              />
            </div>
          </div>
          <hr />
        </div>
      </div>
      <div className="row border m-1 p-2">
        <div className="col-2">
          <Typography fontSize="12px" fontWeight="bold">
            Estado
          </Typography>
          <Controller
            control={control}
            name="filtro.estado"
            render={({ field }) => (
              <Select
                id="select-empleado"
                classNamePrefix="select"
                isSearchable={true}
                placeholder="Seleccionar Estado"
                options={estadosList}
                getOptionLabel={(option) => option.descripcion}
                getOptionValue={(option) => option.id}
                onChange={(e) => field.onChange(e.id)}
                value={estadosList.find((x) => x.id === field.value)}
              />
            )}
          />
        </div>
        <div className="col-3">
          <Typography fontSize="12px" fontWeight="bold">
            Mensajero
          </Typography>
          <Controller
            control={control}
            name="filtro.mensajeroId"
            render={({ field }) => (
              <Select
                id="select-empleado"
                classNamePrefix="select"
                isSearchable={true}
                placeholder="Seleccionar Mensajero"
                options={mensajeroList}
                getOptionLabel={(option) => option.nombreEmpleado}
                getOptionValue={(option) => option.id}
                onChange={(e) => field.onChange(e.id)}
                value={mensajeroList.find((x) => x.id === field.value)}
              />
            )}
          />
        </div>
        <div className="col-3">
          <Typography fontSize="12px" fontWeight="bold">
            Área Organizacional
          </Typography>
          <Controller
            control={control}
            name="filtro.areaOrganizacionalId"
            render={({ field }) => (
              <Select
                id="select-area"
                classNamePrefix="select"
                isSearchable={true}
                placeholder="Seleccionar Área"
                options={listaAreasState}
                getOptionLabel={(option) => option.nombre}
                getOptionValue={(option) => option.id}
                onChange={(e) => field.onChange(e.id)}
                value={listaAreasState.find((x) => x.id === field.value)}
              />
            )}
          />
        </div>
        <div className="col-1">
          <button id="limpiar-button" className="btn btn-danger" style={{ marginTop: 17 }} onClick={() => reset()}>
            <CleaningServices />
          </button>
        </div>
        <div className="col-3">
          <div className="d-flex justify-content-end">
            <button
              id="agregar-button"
              className="btn btn-primary-mem"
              style={{ marginTop: 17 }}
              onClick={() => setOpenModalRegisterOrUpdate({ ...openModalRegisterOrUpdate, open: true })}
            >
              Crear Nueva Solicitud <IoAddCircle style={{ marginBottom: 4 }} fontSize="22" />
            </button>
          </div>
        </div>
      </div>

      <Paper>
        <Stack mt={2} p={3}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', width: '5%' }}>HORA</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>DEPARTAMENTO</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>DEPARTAMENTOS RECEPCIÓN</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '5%' }} align="center">
                    EXTENSIÓN
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>SOLICITANTE</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>MOTIVO</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>MENSAJERO</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>OBSERVACIONES</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '10%' }} align="center">
                    ESTADO
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {controlMensajeria.length > 0 ? (
                  controlMensajeria.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.hora}</TableCell>
                      <TableCell>{item.areaOrganizacional}</TableCell>
                      <TableCell>
                        {item.departamentosRecepcion.length === 0 ? (
                          'N/A'
                        ) : (
                          <ul>
                            {item.departamentosRecepcion.map((departamento, index) => (
                              <li key={index}>{departamento.nombre}</li>
                            ))}
                          </ul>
                        )}
                      </TableCell>
                      <TableCell align="center">{item.extension}</TableCell>
                      <TableCell>{item.solicitante}</TableCell>
                      <TableCell>{item.motivo}</TableCell>
                      <TableCell>{item?.mensajero}</TableCell>
                      <TableCell>{item?.observaciones}</TableCell>
                      <TableCell align="center">
                        <ColorEstatus estado={item.estadoMensajeria.descripcion} />
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => setOpenHistorico({ open: true, historico: item.historico })}>
                          <FaEye color="#003876" />
                        </IconButton>
                        <IconButton
                          hidden={item.estadoMensajeria.id === EstadosControlCafeteriaEnum.Completado}
                          onClick={() => setOpenModalRegisterOrUpdate({ open: true, controlMensajeria: item, editEnabled: true })}
                        >
                          <MdModeEdit color="#003876" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableCell colSpan={9} align="center">
                    <Typography>No hay registros</Typography>
                  </TableCell>
                )}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={controlMensajeriaCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Stack>
      </Paper>

      <HistoricoModal data={openHistorico} setOpenHistorico={setOpenHistorico} />

      <InsertOrUpdateModal
        openModalRegisterOrUpdate={openModalRegisterOrUpdate}
        setOpenModalRegisterOrUpdate={setOpenModalRegisterOrUpdate}
        form={form2}
      />

      <Loading open={isLoading} />
    </div>
  );
};
